import { render, staticRenderFns } from "./ItemizerFontPicker.vue?vue&type=template&id=356d44a4&"
import script from "./ItemizerFontPicker.vue?vue&type=script&lang=js&"
export * from "./ItemizerFontPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports